import { render, staticRenderFns } from "./GenerarInvitaciones.vue?vue&type=template&id=1a635c8d"
import script from "./GenerarInvitaciones.vue?vue&type=script&lang=js"
export * from "./GenerarInvitaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports